var map = {
	"./img1.jpg": 58820,
	"./img10.jpg": 86782,
	"./img2.jpg": 44000,
	"./img3.jpg": 47613,
	"./img4.jpg": 26356,
	"./img5.jpg": 89647,
	"./img6.jpg": 42165,
	"./img7.jpg": 467,
	"./img8.jpg": 57925,
	"./img9.jpg": 95067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8762;